import { recordAction } from '../actions/fetchrecord'
import { recordMutation } from '../mutations/fetchrecord'

export const record = {
  state: {
    'record/car': {
      data: []
    },
    'record/person': {
      data: []
    },
    'record/abstract': {
      data: []
    },
		'record/maintain': {
      data: []
    },
		'record/illegal': {
      data: []
    },
		'record/insurance': {
      data: []
    },
		'record/taobao': {
      data: []
    },
		'record/jingdong': {
      data: []
    },
		'record/security': {
      data: []
    },
		'record/executor': {
      data: []
    },
    'record/house': {
      data: []
    }
  },
  mutations: recordMutation,
  actions: recordAction
}



// WEBPACK FOOTER //
// ./src/store/modules/fetchrecord.js